import { useEffect } from "react";
import { TourHelperProps } from "./types";
import { HelperProps } from "tour-navigator/lib/TourNavigator/types";

export default function TourHelperTooltip({
  hideArrow,
  arrowStyle,
  helperStyle,
  helperBackgroundStyle,
  firstButtonStyle,
  lastButtonStyle,
  headerStyle,
  descriptionStyle,
  onComplete,
  firstButtonText,
  lastButtonText,
  handleFirstButtonClick,
  handleLastButtonClick,
  currentStep,
  onRequestClose,
  next,
  currentStepIndex,
  steps,
  finalButtonText,
  footerText,
  footerLink,
  showFooter = true,
  ...props
}: TourHelperProps) {
  const helperProps: HelperProps = {
    currentStep,
    onRequestClose,
    next,
    currentStepIndex,
    steps,
    ...props,
  };
  const isFirst = currentStepIndex === 0;
  let isLast = false;

  if (steps && steps.length > 0) {
    isLast = currentStepIndex === steps.length - 1;
  }

  const handleNext = () => {
    if (isLast) return onComplete?.();
    next();
  };

  const prevButtonText =
    firstButtonText && typeof firstButtonText === "function"
      ? firstButtonText(currentStepIndex)
      : firstButtonText;
  const nextButtonText =
    lastButtonText && typeof lastButtonText === "function"
      ? lastButtonText(currentStepIndex)
      : lastButtonText;
  const finalButtonText2 =
    finalButtonText && typeof finalButtonText === "function"
      ? finalButtonText(currentStepIndex)
      : finalButtonText;

  return (
    <div className="tour-helper-tooltip">
      {hideArrow ? null : (
        <div className="tour-helper-pointer" style={arrowStyle} />
      )}
      <div
        className="tour-helper-content"
        style={{ ...helperBackgroundStyle, ...helperStyle }}
      >
        <div className={`tour-helper-tooltip-details`}>
          <h1 style={headerStyle}>{currentStep?.data?.title}</h1>
          <p style={descriptionStyle}>{currentStep?.data?.description}</p>
        </div>
        <div className="tour-helper-tooltip-button">
          {!isLast && (
            <button
              className="tour-helper-button transparent"
              style={firstButtonStyle}
              onClick={(e: unknown) =>
                handleFirstButtonClick
                  ? handleFirstButtonClick(helperProps)
                  : onRequestClose?.({
                      event: e as MouseEvent,
                      isMask: false,
                      isOverlay: false,
                    })
              }
            >
              <span>{prevButtonText || "Skip"}</span>
            </button>
          )}
          <button
            className="tour-helper-button outline"
            style={lastButtonStyle}
            onClick={() =>
              handleLastButtonClick
                ? handleLastButtonClick(helperProps)
                : handleNext()
            }
          >
            <span>
              {isLast
                ? finalButtonText2 || "Get Started"
                : nextButtonText || "Next"}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
